import * as React from 'react';
import {
    ReferenceArrayField,
    SingleFieldList,
    ChipField,
    useRecordContext,
    useGetMany,
} from 'react-admin';
import { Box, Chip, Typography } from '@mui/material';

const ColoredChipField = (props: any) => {
    const record = useRecordContext();
    if (!record) return null;
    return (
        <ChipField
            record={record}
            {...props}
            style={{ backgroundColor: record.color, border: 0 }}
            component="span"
        />
    );
};

const LimitedTagsList = ({ limit }: { limit: number }) => {
    const record = useRecordContext();
    const { data: tags } = useGetMany(
        'tags',
        { ids: record?.tags || [] },
        { enabled: record && record.tags && record.tags.length > 0 }
    );

    if (!tags || tags.length === 0) return null;

    const visibleTags = tags.slice(0, limit);
    const remainingCount = tags.length - limit;

    return (
        <Box component="span" sx={{ display: 'inline-block' }}>
            {visibleTags.map(tag => (
                <Chip
                    key={tag.id}
                    component="span"
                    label={tag.name}
                    variant="filled"
                    size="small"
                    style={{
                        marginRight: 4,
                        marginBottom: 4,
                    }}
                    sx={{
                        '&.MuiChip-colorDefault': {
                            color: 'black',
                            backgroundColor: tag.color || undefined,
                            border: 0,
                        },
                    }}
                />
            ))}
            {remainingCount > 0 && (
                <Typography
                    component="span"
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                        fontSize: '0.75rem',
                    }}
                >
                    and {remainingCount} more
                </Typography>
            )}
        </Box>
    );
};

export const TagsList = ({ limit }: { limit?: number }) => {
    if (limit) {
        return (
            <ReferenceArrayField
                sx={{ display: 'inline-block' }}
                resource="member"
                source="tags"
                reference="tags"
            >
                <LimitedTagsList limit={limit} />
            </ReferenceArrayField>
        );
    }

    return (
        <ReferenceArrayField
            sx={{ display: 'inline-block' }}
            resource="member"
            source="tags"
            reference="tags"
        >
            <SingleFieldList linkType={false} component="span">
                <ColoredChipField
                    source="name"
                    variant="outlined"
                    size="small"
                />
            </SingleFieldList>
        </ReferenceArrayField>
    );
};
